import isEmpty from 'lodash/isEmpty';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../campaign-purchase-order.i18n.json'));

import type {
  CampaignPurchaseOrder,
  CampaignPurchaseOrderBackendResponse
} from '../types';

export const MAX_CHAR_COUNTS = {
  pon: 100,
  costCenter: 200
};

export const PURCHASE_ORDER: CampaignPurchaseOrder = {
  id: null,
  pon: {
    identifier: 'pon',
    value: '',
    isChecked: false,
    isSaved: false
  },
  costCenter: {
    identifier: 'costCenter',
    value: '',
    isChecked: false,
    isSaved: false
  }
};

export const MSG_KEY = 'campaign_purchase_order';

export const generateErrorMsg = (
  error: any,
  campaignId: number,
  purchaseOrderId: number | null
): string => {
  const errorMsgFromBE = error?.response?.data?.detail;
  const errorMsgByCode = __t(`${MSG_KEY}.errors.${error?.response?.data?.code}`, {
    campaignId,
    purchaseOrderId
  });

  return errorMsgFromBE || errorMsgByCode || __t(`${MSG_KEY}.errors.service`);
};

export const buildPurchaseOrder = (
  result: CampaignPurchaseOrderBackendResponse | null
): CampaignPurchaseOrder => {
  const ponValue = result?.pon ?? PURCHASE_ORDER.pon.value;
  const costCenterValue = result?.costCenter ?? PURCHASE_ORDER.costCenter.value;

  return {
    ...PURCHASE_ORDER,
    id: result?.id ?? PURCHASE_ORDER.id,
    pon: {
      ...PURCHASE_ORDER.pon,
      value: ponValue,
      isChecked: !isEmpty(ponValue),
      isSaved: !isEmpty(ponValue)
    },
    costCenter: {
      ...PURCHASE_ORDER.costCenter,
      value: costCenterValue,
      isChecked: !isEmpty(costCenterValue),
      isSaved: !isEmpty(costCenterValue)
    }
  };
};
